module.exports = __webpack_public_path__ + "media/images/badges/cyclebar-badge-5a02233b65367d7b6c9b470e509fa4f0.svg";